import React from 'react';

/**
 * Visit number display
 */
export const VisitNumberTemplate: React.FC<{ visitNumber?: string }> = ({ visitNumber }) => (
  <span>Visit #{visitNumber}</span>
);

export default VisitNumberTemplate;
